"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TryAgainFallback = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const flora_react_1 = require("@grupoboticario/flora-react");
const Styled_1 = require("./Styled");
const TryAgainFallback = ({ onTryAgainClick }) => {
    return ((0, jsx_runtime_1.jsxs)(Styled_1.Wrapper, { children: [(0, jsx_runtime_1.jsx)(flora_react_1.FloraTypography, Object.assign({ fontSize: "bodyLargeShort", css: { textAlign: 'center' } }, { children: "Houve um erro ao carregar, por favor, tente novamente mais tarde." })), (0, jsx_runtime_1.jsx)(flora_react_1.FloraButton, Object.assign({ onClick: onTryAgainClick }, { children: "Tentar novamente" }))] }));
};
exports.TryAgainFallback = TryAgainFallback;
